import "core-js/stable";
import Vue from "vue";
import { mapGetters } from "vuex";
import { mapFields, updateField } from "vuex-map-fields";
import store from "./store/index";
import GmapVue from "gmap-vue";
import { components } from "gmap-vue";
import dateMixin from "./utils/date-mixin";
import FloatingVue from "floating-vue";

Vue.use(FloatingVue);

import "floating-vue/dist/style.css";
import outages from "../../scss/outages.scss";

import OutagesNav from "./components/OutagesNav.vue";
import OutagesContainer from "./components/OutagesContainer.vue";

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyA9hzViDsJhiaR89I3Atg1ChqCyIGonld0",
    libraries: "places",
  },
  installComponents: true,
});
Vue.mixin(dateMixin);
Vue.component("gmap-cluster", components.Cluster);

Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

// import style from "../../scss/network-status.scss";

/**
 * Pull data from window and populate the store
 * **/
function hydrateApp() {
  const cmsContent = window.cmsContent;
  console.log("CMS Content:", cmsContent);
  if (cmsContent) {
    store.commit("updateField", {
      path: "cmsContent",
      value: cmsContent,
    });
  }
}

/**
 * Set up config
 * **/
function init() {
  hydrateApp();

  store.dispatch("getAllOutages").then(() => {
    new Vue({
      el: "#outages-app",
      store,
      components: {
        OutagesNav,
        OutagesContainer,
      },
      computed: {
        ...mapFields(["plannedOutages", "unplannedOutages"]),
        ...mapGetters([]),
      },
      methods: {},
      mounted() {
        console.log("app loaded");
        //log out plnned and unplanned outages
        console.log(this.plannedOutages);
        console.log(this.unplannedOutages);
      },
      destroyed() {},
    });
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
